

import { AiFillFacebook } from "react-icons/ai";
import { RiTwitterXFill } from "react-icons/ri";
import { LuInstagram } from "react-icons/lu";
import { IoLogoYoutube } from "react-icons/io5";
import { FaRss } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import Link from "next/link";
import { useLocale } from "next-intl";
import { BsWhatsapp } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa6";



export default function SocialMedia() {

  const locale = useLocale()


  return (
    <div className="flex w-full gap-3 text-primary justify-center items-center">
       <Link href="https://www.facebook.com/" target="_blank" title="Facebook Account">
        <FaFacebook size={32} className=" hover:text-bl cursor-pointer"/>
       </Link>
    <Link href="https://www.instagram.com/" target="_blank" title="Instagram Account">
     <LuInstagram size={32} className=" hover:text-orange-700 cursor-pointer"/>
    </Link>
    <Link href="https://www.tiktok.com/" target="_blank" title="TikTok Account">
    <FaTiktok size={32} className=" hover:text-a cursor-pointer"/>
    </Link>
    <Link href="https://wa.me/213772057037" target="_blank" title="WhatsApp">
    <BsWhatsapp size={32} className=" cursor-pointer hover:text-green-700"/>
    </Link>
    <Link href={`/${locale}/rss`} target="_blank" rel="noopener noreferrer" title="RSS Feed"> 
    <FaRss size={32} className=" hover:text-primary cursor-pointer"/>
    </Link>
   

  </div>
  );
}